import { useCurrenciesMasterdataQuery } from "./currencies-masterdata-query";
import { useGeoCountriesMasterdataQuery } from "./geo-countries-masterdata-query";
import { useGeoCitiesMasterdataQuery } from "./geo-cities-masterdata-query";
import { useMarketsMasterdataQuery } from "./markets-masterdata-query";
import { useExperienceCategoriesMasterdataQuery } from "./experience-categories-masterdata-query";
import { useExperienceInterestsMasterdataQuery } from "./experience-interests-masterdata-query";
import { useSuppliersMasterdataQuery } from "./suppliers-masterdata-query";
import { useHighlightsMasterdataQuery } from "./highlights-masterdata-query";
import { useIncludedMasterdataQuery } from "./included-masterdata-query";
import { useImportantInformationMasterdataQuery } from "./important-information-masterdata-query";
import { useAdditionalServicesMasterdataQuery } from "./additional-services-masterdata-query";
import { useHierarchicalGroupsMasterdataQuery } from "./hierarchical-groups-masterdata-query";

export function useAllMasterdataQuery() {
  const currenciesQuery = useCurrenciesMasterdataQuery();
  const geoCountriesQuery = useGeoCountriesMasterdataQuery();
  const geoCitiesQuery = useGeoCitiesMasterdataQuery();
  const marketsQuery = useMarketsMasterdataQuery();
  const experienceCategoriesQuery = useExperienceCategoriesMasterdataQuery();
  const experienceInterestsQuery = useExperienceInterestsMasterdataQuery();
  const suppliersQuery = useSuppliersMasterdataQuery();
  const highlightsQuery = useHighlightsMasterdataQuery();
  const includedQuery = useIncludedMasterdataQuery();
  const importantInformationQuery = useImportantInformationMasterdataQuery();
  const additionalServicesQuery = useAdditionalServicesMasterdataQuery();
  const hierarchicalGroupsQuery = useHierarchicalGroupsMasterdataQuery();

  const queries = [
    currenciesQuery,
    geoCountriesQuery,
    geoCitiesQuery,
    marketsQuery,
    experienceCategoriesQuery,
    experienceInterestsQuery,
    suppliersQuery,
    highlightsQuery,
    includedQuery,
    importantInformationQuery,
    additionalServicesQuery,
    hierarchicalGroupsQuery,
  ];

  const isLoading = computed(() => queries.some((q) => q.isLoading?.value));
  const isError = computed(() => queries.some((q) => q.isError?.value));

  async function refetchAll() {
    await Promise.all(queries.map((q) => q.refetch?.()));
  }

  return {
    isLoading,
    isError,
    refetchAll,
  };
}
